import { db, functions } from '@/firebase';
import moment from 'moment';
import state from '../tareasProgramadas/state';
export default {
  getTodosCatalogos({ state, dispatch }) {
    return Promise.all(
      state.catalogos.map((c) => {
        return dispatch('getCatalogo', c.value);
      })
    );
  },
  getCatalogo({ commit, rootState }, catalogo) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('catalogos')
      .doc(catalogo)
      .get()
      .then((r) => {
        commit('setProductosCatalogo', {
          catalogo: catalogo,
          productos: r.exists ? r.data().productos : [],
          tarifa: r.exists ? r.data().tarifa : null,
        });
      });
  },
  getCatalogoArrayRest({ commit, rootState }, { catalogo, arrayRest }) {
    var res = [];
    return Promise.all(
      arrayRest.map((rest) => {
        return db
          .collection('restaurantes')
          .doc(rest.id)
          .collection('catalogos')
          .doc(catalogo)
          .get()
          .then((r) => {
            res.push({
              rest: rest.id,
              productos: r.exists ? r.data().productos : [],
            });
          });
      })
    ).then(() => res);
  },
  setCatalogo({ rootState }, catalogos) {
    let rest = rootState.app.restauranteGest;
    return Promise.all(
      catalogos.map((c) => {
        return db
          .collection('restaurantes')
          .doc(rest)
          .collection('catalogos')
          .doc(c.catalogo)
          .set(
            {
              productos: c.productos,
            },
            { merge: true }
          );
      })
    );
  },
  setCatalogoRest({}, catalogos) {
    return Promise.all(
      catalogos.map((c) => {
        return db
          .collection('restaurantes')
          .doc(c.rest)
          .collection('catalogos')
          .doc(c.catalogo)
          .set(
            {
              productos: c.productos,
            },
            { merge: true }
          );
      })
    );
  },
  setTarifaCatalogo({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    alert(rest);
    return Promise.all(
      datos.map((c) => {
        return db
          .collection('restaurantes')
          .doc(rest)
          .collection('catalogos')
          .doc(c.catalogo)
          .set(
            {
              tarifa: c.tarifa,
            },
            { merge: true }
          );
      })
    );
  },
  generarCatalogosPublicos({ rootState, dispatch, state }, catalogosFiltrar) {
    const redondeo = (num) => {
      return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
    };
    let rest = rootState.app.restauranteGest;
    let negocio = rootState.app.negocioGest;
    return Promise.all([
      dispatch('getTodosCatalogos'),
      dispatch('productos/getProductos', {}, { root: true }),
      db.collection('caracteristicas').get(),
      db.collection('negocios').doc(negocio).collection('descuentos').get(),
      db.collection('impuestos').get(),
    ])
      .then((r) => {
        let cGlobal =
          r[2].size > 0
            ? r[2].docs.map((c) => {
                return { ...c.data(), id: c.id };
              })
            : [];
        const descuentos =
          r[3].size > 0
            ? r[3].docs.map((d) => {
                return { ...d.data(), id: d.id };
              })
            : [];
        const impuestos =
          r[4].size > 0
            ? r[4].docs.map((d) => {
                return { ...d.data(), id: d.id };
              })
            : [];
        const prdTodos = [...rootState.productos.productosArray];
        return Promise.all(
          state.productosCatalogos
            .filter((c) => catalogosFiltrar.includes(c.catalogo))
            .map((cat) => {
              return db
                .collection('restaurantes')
                .doc(rest)
                .collection('catalogosPublicos')
                .doc(cat.catalogo)
                .set(
                  {
                    productos: cat.productos
                      .map((prd) => {
                        if (prd.activo) {
                          var foundPrd = prdTodos.find((p) => p.id == prd.id);
                          if (foundPrd) {
                            //el genérico se añade en cliente
                            var prodIncluir = {
                              // ...foundPrd,
                              ...prd,
                            };
                            /************************** INICIO Bloque de CARACTERÍSTICAS **************************/
                            let cs = prd.caractSeleccionadas;
                            if (!cs) cs = [];
                            let caracts = [];
                            cs.forEach((c) => {
                              let find_c = cGlobal.find((e) => e.id == c);
                              if (find_c) {
                                let find_grupo = caracts.find(
                                  (e) => e.grupo == find_c.grupo
                                );
                                if (find_grupo) {
                                  find_grupo.caracteristicas.push({
                                    nombre: find_c.nombre,
                                    id: find_c.id,
                                    img: find_c.imagen,
                                  });
                                } else {
                                  let aux = {
                                    grupo: find_c.grupo,
                                    caracteristicas: [
                                      {
                                        nombre: find_c.nombre,
                                        id: find_c.id,
                                        img: find_c.imagen,
                                      },
                                    ],
                                  };
                                  caracts.push(aux);
                                }
                              }
                            });
                            prodIncluir.caractSeleccionadas = caracts;
                            prodIncluir.precioCobrar = redondeo(
                              prodIncluir.precio
                            );
                            prodIncluir.precioRest = prodIncluir.precioCobrar;

                            /**************************** IMPUESTOS ****************************/
                            let foundImp = impuestos.find(
                              (i) => i.id == prodIncluir.impuesto
                            );
                            if (foundImp) {
                              prodIncluir.impPorcentaje = parseFloat(
                                foundImp.impuesto
                              );
                            }
                            /**************************** OPCIONES ****************************/
                            // prodIncluir.precioCobrar = (prodIncluir.descuentoPorcentaje) ? redondeo(prodIncluir.precioRest * (1 - prodIncluir.descuentoPorcentaje)) : redondeo(prodIncluir.precioRest);
                            const opciones = foundPrd.opciones;
                            var opcionesCatalogo = [];
                            if (Array.isArray(opciones)) {
                              opciones.forEach((panel) => {
                                opcionesCatalogo.push({
                                  ...panel,
                                  opciones: panel.opciones.map((op) => {
                                    var foundOp = prd.opciones.find(
                                      (opCat) => opCat.id == op.id
                                    );
                                    if (foundOp && foundOp.activo) {
                                      return {
                                        ...op,
                                        ...foundOp,
                                        precio: redondeo(foundOp.precio),
                                        precioCobrar: redondeo(foundOp.precio),
                                      };
                                    } else {
                                      return null;
                                    }
                                  }),
                                });
                              });
                            }
                            if (opcionesCatalogo.length > 0)
                              prodIncluir.opciones = opcionesCatalogo;
                            return prodIncluir;
                          }
                        }
                      })
                      .filter((p) => !!p),
                  },
                  { merge: true }
                )
                .then((r) => {})
                .catch((e) => console.log(e));
            })
        ).catch((e) => console.log(e));
      })
      .catch((e) => console.log(e));
  },
  generarCatalogosPublicosFunctionsCheck({ dispatch, state }) {
    if (state.generarAutomaticos)
      return dispatch('generarCatalogosPublicosFunctions');
  },
  generarCatalogosPublicosFunctions({ state, commit, rootState }) {
    commit('setLoadingGenerarCatalogos', true);
    var f = functions.httpsCallable('httpNegociosGenerarCatalogos');
    if (state.generarCatalogoObj.restaurantes.length == 0) {
      commit('setGenerarCatalogoObjValor', {
        key: 'negocio',
        value: rootState.app.negocioGest,
      });
      commit('setGenerarCatalogoObjValor', {
        key: 'catalogos',
        value: state.catalogos.map((c) => c.value),
      });
      if (state.generarCatalogoObj.productos.length == 0) {
        commit('setGenerarCatalogoObjValor', {
          key: 'productos',
          value: rootState.productos.productosArray
            .filter((p) => !!p.individualPedible)
            .map((c) => c.id),
        });
      }
    }
    return f(state.generarCatalogoObj)
      .then((res) => {
        commit(
          'snackbar/setMensajeSuccess',
          {
            msj: 'Catálogo generado',
          },
          { root: true }
        );
        commit('resetGenerarCatalogoObj');
      })
      .catch((error) => {
        commit(
          'snackbar/setMensajeDanger',
          {
            msj: 'Error al generar el catálogo ' + error,
          },
          { root: true }
        );
      })
      .finally(() => {
        commit('setLoadingGenerarCatalogos', false);
      });
  },
  migrarACatalogo({ rootState, rootGetters, state }, { rest, catalogo }) {
    rest = rest ? rest : rootState.app.restauranteGest;
    console.log(rootGetters['app/restGestObj']);
    // let restObj = JSON.parse(JSON.stringify(rootGetters['app/restGestObj']))
    let a = rootState.restaurantes.restaurantesArray;
    let restObj = a.find((e) => e.id == rest);
    let productos = [];
    if (
      restObj.productosAsociados &&
      Array.isArray(restObj.productosAsociados)
    ) {
      console.log(catalogo);
      console.log(state.productosCatalogos);

      var foundCatalogo = state.productosCatalogos.find(
        (cat) => cat.catalogo == catalogo
      );
      console.log(foundCatalogo);
      if (foundCatalogo) {
        console.log(restObj.productosAsociados);
        restObj.productosAsociados.map((prd) => {
          let foundIndex = foundCatalogo.productos.findIndex(
            (p) => p.id == prd.id
          );
          console.log(foundIndex);
          if (foundIndex > -1) {
            console.log(prd.opciones);
            foundCatalogo.productos[foundIndex].precio = prd.precioRest;
            foundCatalogo.productos[foundIndex].impuesto = prd.impuesto;
            foundCatalogo.productos[foundIndex].activo = true;
            foundCatalogo.productos[foundIndex].opciones = prd.opciones.map(
              (op) => {
                return {
                  activo: op.asociado,
                  id: op.id,
                  precio: op.precio,
                };
              }
            );
          }
        });
        console.log(foundCatalogo);
        return db
          .collection('restaurantes')
          .doc(rest)
          .collection('catalogos')
          .doc(catalogo)
          .set(
            {
              productos: foundCatalogo.productos,
            },
            { merge: true }
          )
          .catch((e) => {
            console.log(e);
          });
      }
    }
  },
  migrarACatalogoTodos({ state, rootState, dispatch }) {
    return dispatch('resetearCatalogo')
      .then(() => {
        return dispatch('getTodosCatalogos');
      })
      .then(() => {
        return state.catalogos.map((c) => {
          console.log(c);
          return dispatch('migrarACatalogo', {
            rest: rootState.app.restauranteGest,
            catalogo: c.value,
          });
        });
      })
      .then(() => {
        return dispatch('getTodosCatalogos');
      })
      .catch((e) => console.log(e));
  },
  resetearCatalogo({ rootState, state, rootGetters }) {
    let rest = rootState.app.restauranteGest;
    let restObj = rootGetters['app/restGestObj'];
    let productos = [...rootState.productos.productosArray];
    return Promise.all(
      state.catalogos.map((c) => {
        return db
          .collection('restaurantes')
          .doc(rest)
          .collection('catalogos')
          .doc(c.value)
          .set(
            {
              productos: productos.map((p) => {
                let opciones =
                  p.opciones && Array.isArray(p.opciones)
                    ? p.opciones.map((panel) => {
                        return panel.opciones.map((op) => {
                          return {
                            id: op.id,
                            precio: op.precio ? op.precio : 0,
                            activo: false,
                          };
                        });
                      })
                    : [];
                return {
                  id: p.id,
                  precio: parseFloat(p.precioGlobal ? p.precioGlobal : 0),
                  impuesto: restObj.impuesto,
                  activo: false,
                  opciones: opciones.flat(),
                };
              }),
            },
            { merge: true }
          );
      })
    ).catch((e) => console.log(e));
  },
  addTareaProgramadaGenerarCatalogo({ dispatch, state }) {
    commit('setGenerarCatalogoObjValor', {
      key: 'negocio',
      value: rootState.app.negocioGest,
    });
    commit('setGenerarCatalogoObjValor', {
      key: 'catalogos',
      value: state.catalogos.map((c) => c.value),
    });
    return dispatch('tareasProgramadas/addTareaProgramada', {
      tipo: 'generarCatalogo',
      fechaEjecucion: moment().add(5, 'minutes').toDate(),
      ...state.generarCatalogoObj,
    });
  },
};
